module.exports = __webpack_public_path__ + "static/media/cursor.2be4c54c.png";